module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    class: [{
      disabled: _vm.firstPageSelected()
    }]
  }, [_c('a', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        _vm.prevPage()
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.prevPage()
      }
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      class: [{
        active: page.selected,
        disabled: page.disabled
      }]
    }, [(page.disabled) ? _c('a', {
      attrs: {
        "tabindex": "0"
      }
    }, [_vm._v(_vm._s(page.content))]) : _c('a', {
      attrs: {
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          _vm.handlePageSelected(page.index)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
          _vm.handlePageSelected(page.index)
        }
      }
    }, [_vm._v(_vm._s(page.content))])])
  }), _vm._v(" "), _c('li', {
    class: [{
      disabled: _vm.lastPageSelected()
    }]
  }, [_c('a', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        _vm.nextPage()
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.nextPage()
      }
    }
  }, [_vm._v("Next")])])], 2), _vm._v(" "), _vm._t("other"), _vm._v(" "), _vm._l((_vm.itemList), function(item) {
    return _vm._t("item", null, {
      item: item
    })
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-213d5690", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-213d5690","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Paginate.vue
// module id = 53
// module chunks = 0 1